import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { MoreVertical, Archive, AlertCircle } from 'lucide-react';

interface ArchiveMenuDropdownProps {
    onShowArchivedWorkOrders: () => void;
    onShowArchivedIssues: () => void;
}

/**
 * Three-dots dropdown menu for accessing archived work orders and issues
 */
const ArchiveMenuDropdown: React.FC<ArchiveMenuDropdownProps> = ({
    onShowArchivedWorkOrders,
    onShowArchivedIssues
}) => {
    return (
        <Dropdown>
            <Dropdown.Toggle
                variant="outline-secondary"
                size="sm"
                className="d-flex align-items-center justify-content-center dropdown-toggle-no-caret"
                style={{ width: 44, height: 44, padding: 0 }}
            >
                <MoreVertical size={18} />
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
                <Dropdown.Item onClick={onShowArchivedWorkOrders}>
                    <Archive size={14} className="me-2" />
                    Arkiverade ärenden
                </Dropdown.Item>
                <Dropdown.Item onClick={onShowArchivedIssues}>
                    <AlertCircle size={14} className="me-2" />
                    Arkiverade felanmälningar
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ArchiveMenuDropdown;
